import { Directive, OnInit, AfterViewInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { delay, filter } from 'rxjs/operators';
import { InputAutocompleteComponent } from '@nimbus-library/features/shared/components/material/input-autocomplete/input-autocomplete.component';
@UntilDestroy()
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'nimbus-input-autocomplete[defaultHighlight]',
  standalone: false,
})
export class InputAutocompleteDefaultHighlightDirective implements OnInit, AfterViewInit {
  public constructor(private readonly host: InputAutocompleteComponent) {}

  public ngOnInit(): void {
    this.host.autoCompleteControl.valueChanges
      .pipe(
        filter((val) => typeof val === 'string'),
        untilDestroyed(this),
      )
      .subscribe((val: string) => {
        const index = this.findOptionIndexByValue(val.trim());

        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        if (index !== -1) {
          this.activateOption(index);
        }
      });
  }

  public ngAfterViewInit(): void {
    this.host.autocomplete.opened.pipe(delay(0), untilDestroyed(this)).subscribe(() => {
      const val = this.host.autoCompleteControl.getRawValue();
      if (val) {
        const searchVal = typeof val === 'string' ? val : val?.name;
        const index = this.findOptionIndexByValue(searchVal);

        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        if (index !== -1) {
          this.activateOption(index);
        }
      }
    });
  }

  private findOptionIndexByValue(value: string): number {
    return this.host.options.findIndex((o) => o?.name?.toLowerCase()?.includes(value?.toLowerCase()));
  }

  private activateOption(index: number): void {
    const option = this.host.autocomplete.options.get(index);
    this.host.autocomplete._keyManager.setActiveItem(option);
    (this.host.autocomplete.panel?.nativeElement as HTMLElement)?.scrollTo(0, option._getHostElement().offsetTop);
  }
}
